import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDuration(seconds: number): string {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  return `${hours}h${minutes.toString().padStart(2, '0')}`
}

export function formatTime(date: Date): string {
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  })
}

export function formatDate(date: Date): string {
  return date.toLocaleDateString('en-US', {
    day: '2-digit',
    month: 'short',
    year: '2-digit'
  }).toUpperCase()
}

export function generateToken(): string {
  const array = new Uint8Array(32)
  crypto.getRandomValues(array)
  return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('')
}

export function generateCode(length: number = 6): string {
  const digits = '0123456789'
  const array = new Uint8Array(length)
  crypto.getRandomValues(array)
  return Array.from(array, byte => digits[byte % 10]).join('')
}

// Generate a unique identifier for instructors/students (e.g., "IRO-A3K9")
export function generateIdentifier(): string {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789' // No I/O/0/1 to avoid confusion
  const array = new Uint8Array(4)
  crypto.getRandomValues(array)
  const suffix = Array.from(array, byte => chars[byte % chars.length]).join('')
  return `IRO-${suffix}`
}

// Generate a 6-digit permanent access code
export function generateAccessCode(): string {
  return generateCode(6)
}
